export var SettlementStatus;
(function (SettlementStatus) {
    SettlementStatus["Open"] = "Open";
    SettlementStatus["Lost"] = "Lost";
    SettlementStatus["Won"] = "Won";
    SettlementStatus["Placed"] = "Placed";
    SettlementStatus["WonDeadHeat"] = "WonDeadHeat";
    SettlementStatus["PlacedDeadHeat"] = "PlacedDeadHeat";
    SettlementStatus["Draw"] = "Draw";
    SettlementStatus["Cancelled"] = "Cancelled";
    SettlementStatus["NonRunner"] = "NonRunner";
    SettlementStatus["HalfLost"] = "HalfLost";
    SettlementStatus["HalfWon"] = "HalfWon";
    SettlementStatus["CashOut"] = "CashOut";
})(SettlementStatus || (SettlementStatus = {}));
//# sourceMappingURL=SettlementStatus.js.map